import { Event } from '../Event'
import { Identity } from '../../constants'

export interface ArticleSocialShareClickedEventProperties {
  article_id: string
  medium: 'linkedin' | 'facebook' | 'twitter'
}

export class ArticleSocialShareClickedEvent extends Event<
  ArticleSocialShareClickedEventProperties
> {
  static displayName = 'Article Social Share Clicked'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
